import EmptyValue from './EmptyValue';

export default EmptyValue;
